import searchHelper from '../search/searchHelper'

const helpHubSearch = (data) => ({
    ...searchHelper,
    query: '',
    emptySearchData: JSON.parse(decodeURIComponent(data.emptySearchData)) || [],
    submitUrl: data.submitUrl,
    currentIso: window.accuvars.language.iso_code,
    cmsHitCount: 0,
    cmsResults: [],
    showSearchResults: false,
    loading: false,
    cmsToRetrieve: 3,
    hardcodedFacetSearch: false,
    hardcodedFacetIds: process.env.MIX_HELP_HUB_NO_SEARCH_RESULTS,
    categoryIds: data.searchableCategoryIds,
    cmsQueryId: null,
    init() {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('help-query') != null) {
            this.query = urlParams.get('help-query')
        }
    },
    resetStats() {
        this.cmsHitCount = 0
        this.cmsResults = []
        this.showSearchResults = false
        window.Alpine.store('general').showOverlay = this.showSearchResults
    },
    hideSearch() {
        if (!this.showSearchResults) {
            return
        }
        this.showSearchResults = false
        window.Alpine.store('general').showOverlay = false
    },
    decideToShow(event) {
        // we have just clicked on input, but maybe we already had searched string and have results
        this.showSearchResults = this.hits > 0
        window.Alpine.store('general').showOverlay = this.showSearchResults
        // if this was a search page, then we have content in search without searching
        // hence we need to trigger search
        // if (this.query.trim() !== '' && this.showSearchResults === false) {
        //     this.performSearch(event)
        // }
        this.performSearch(event)
    },
    performSearch(event) {
        if (this.query.trim() === '') {
            this.hardcodedFacetSearch = true
            this.cmsResults = this.emptySearchData
            this.cmsHitCount = this.emptySearchData.length
            this.showSearchResults = this.cmsHitCount > 0
            return true
        }
        this.hardcodedFacetSearch = false

        let facetFilters = {}

        if (!this.hardcodedFacetSearch) {
            if (
                event.type !== 'click' && event.which === 13
            ) {
                // submit form on ENTER press
                return true
            }

            if (
                event.type !== 'click'
                && String.fromCharCode(event.keyCode).match(/(\w|\s|\W)/g) === null
                && event.which !== 8
                && event.which !== 32
            ) {
                // non char key, dont trigger search
                // but accept backspace or space or click since it changes string
                return true
            }
            this.updateUrl()
            facetFilters = `[[${this.categoryIds.split(',').map((el) => `"category_id:${el}"`).join(',')}]]`
        } else {
            facetFilters = `[[${this.hardcodedFacetIds.split(',').map((el) => `"objectID:${el}"`).join(',')}]]`
        }

        // build query array, for cms just one entry
        const queries = [
            {
                indexName: 'new_cms_pages',
                query: this.query,
                restrictSearchableAttributes: [
                    `${this.currentIso}.title`,
                    `${this.currentIso}.meta_title`,
                    `${this.currentIso}.meta_keywords`,
                    `${this.currentIso}.meta_description`,
                ],
                params: {
                    hitsPerPage: this.cmsToRetrieve,
                    facetFilters,
                },
                clickAnalytics: true,
            },
        ]

        window.api.search(queries).then((searchResults) => {
            // no indexes means some went wrong , but handle with reset
            if (searchResults.length === 0) {
                this.resetStats()
            } else {
                const cmsResults = searchResults[0]
                // 2nd resultset are products (+category extras for now)
                this.cmsResults = cmsResults.hits
                this.cmsHitCount = cmsResults.nbHits
                this.cmsQueryId = cmsResults.queryID
                this.showSearchResults = this.cmsHitCount > 0
            }
        }).catch((e) => {
            this.$dispatch('create-toast', {
                title: 'We encountered a problem...',
                message: e,
                type: 'error',
            })
        })

        return true
    },
    updateUrl() {
        const filters = {}

        if (this.query !== '') {
            filters['help-query'] = this.query
        }

        const query = window.helpers.buildQueryString(filters)
        const nextURL = `${window.location.pathname}?${query}`.replace(/\?$/, '')
        window.history.pushState(null, document.title, nextURL)
    },
    get urlEncodeSearchHelpHub() {
        const x = `?help-query=${encodeURIComponent(this.query)}`
        return x
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('helpHubSearch', helpHubSearch)
})
